module.exports = __webpack_public_path__ + "img/1-6.d8d69b1a.jpg";